import { useFlags } from 'launchdarkly-react-client-sdk';
import { session } from '../../../services/session';

const Flag = ({ name, children }) => {
  const flags = useFlags();
  // Temporarily include adminView logic until LaunchDarkly is QAed
  return flags[name] || session.isAdminView ? children : null;
};

export default Flag;
